/* Year > Make > Model cascading picker. Data is inlined by snippets/fitment-form.liquid from the navigation menu. */
(function () {
  'use strict';
  function init(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    var raw = form.querySelector('[data-fit-data]');
    var data = [];
    try { data = JSON.parse(raw.textContent); } catch (e) { return; }
    var year = form.querySelector('[data-fit-year]'), make = form.querySelector('[data-fit-make]'), model = form.querySelector('[data-fit-model]'), btn = form.querySelector('[data-fit-submit]');
    var target = '';
    var remembered = null;
    try { remembered = JSON.parse(localStorage.getItem('st_fit') || 'null'); } catch (e) {}

    function fill(select, items, placeholder) {
      select.innerHTML = '<option value="">' + placeholder + '</option>' + items.map(function (it, i) { return '<option value="' + i + '">' + it.t + '</option>'; }).join('');
      select.disabled = !items.length;
    }
    var choose = year.options[0].textContent;
    /* Years come from the data, which already leaves out cars with nothing to buy in this market. */
    fill(year, data, choose);

    year.addEventListener('change', function () {
      var y = data[year.value];
      fill(make, y ? y.makes : [], choose);
      fill(model, [], choose);
      target = ''; btn.disabled = true;
      if (y && y.makes.length === 1) { make.value = '0'; make.dispatchEvent(new Event('change')); }
    });
    make.addEventListener('change', function () {
      var y = data[year.value], mk = y && y.makes[make.value];
      fill(model, mk ? mk.models : [], choose);
      target = ''; btn.disabled = true;
      if (mk && mk.models.length === 1) { model.value = '0'; model.dispatchEvent(new Event('change')); }
      else if (mk && !mk.models.length) { target = mk.u; btn.disabled = false; }
    });
    model.addEventListener('change', function () {
      var y = data[year.value], mk = y && y.makes[make.value], md = mk && mk.models[model.value];
      target = md ? md.u : (mk ? mk.u : '');
      btn.disabled = !target;
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!target) return;
      try { localStorage.setItem('st_fit', JSON.stringify({ y: year.value, m: make.value, d: model.value, yt: year.selectedOptions[0].text, mt: make.selectedOptions[0].text, dt: model.selectedOptions[0] ? model.selectedOptions[0].text : '', label: [year.selectedOptions[0].text, make.selectedOptions[0].text, model.selectedOptions[0] ? model.selectedOptions[0].text : ''].join(' ') })); } catch (err) {}
      btn.classList.add('is-loading');
      window.location.href = target;
    });

    /* Restore the last car by name (indexes differ between markets because empty fitments are dropped). */
    function pick(select, text, fallback) {
      var idx = -1;
      if (text) { for (var i = 1; i < select.options.length; i++) { if (select.options[i].text === text) { idx = i - 1; break; } } }
      else if (fallback != null && select.options[parseInt(fallback, 10) + 1]) { idx = parseInt(fallback, 10); }
      if (idx < 0) return false;
      select.value = String(idx); select.dispatchEvent(new Event('change')); return true;
    }
    if (remembered) {
      if (pick(year, remembered.yt, remembered.yt ? null : remembered.y) && pick(make, remembered.mt, remembered.mt ? null : remembered.m)) {
        pick(model, remembered.dt, remembered.dt ? null : remembered.d);
      }
    }
  }
  function scan() { document.querySelectorAll('[data-fitment]').forEach(init); }
  scan();
  document.addEventListener('shopify:section:load', scan);
  /* Show the remembered vehicle in any [data-fit-label] slot (collection banner, header pill). */
  try {
    var r = JSON.parse(localStorage.getItem('st_fit') || 'null');
    if (r && r.label) document.querySelectorAll('[data-fit-label]').forEach(function (el) { el.textContent = r.label; el.hidden = false; });
  } catch (e) {}
})();
